var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.closed && _vm.visible
    ? _c(
        "div",
        {
          class: {
            callout: true,
            [`callout--${_vm.kind}`]: true,
            "callout--rounded": _vm.rounded,
          },
        },
        [
          _c("div", { staticClass: "callout__body" }, [_vm._t("default")], 2),
          _vm._v(" "),
          _vm.dismissible
            ? _c(
                "button",
                {
                  staticClass: "callout__close",
                  attrs: { type: "button", "aria-label": "Dismiss" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.onCloseRequest.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        "aria-hidden": "true",
                        focusable: "false",
                        fill: "currentColor",
                        height: "16",
                        viewBox: "0 0 16 16",
                        width: "16",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z",
                        },
                      }),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }